import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { db, auth } from "../firebase";
import { doc, setDoc, getDoc, query, collection, where, getDocs } from "firebase/firestore";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const CompanyAuth = () => {
  const [isRegister, setIsRegister] = useState(false);
  const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const navigate = useNavigate();

 
  const handleForgotPassword = async () => {
    if (!email) {
      toast.error("⚠️ Please enter your email first.");
      return;
    }

    const cleanEmail = email.trim().toLowerCase();

    try {
      const q = query(collection(db, "companies"), where("email", "==", cleanEmail));
      const companySnapshot = await getDocs(q);

      if (companySnapshot.empty) {
        toast.error("❌ This email is not registered as a company. Cannot reset password.");
        return;
      }

      await sendPasswordResetEmail(auth, cleanEmail);
      toast.success(
        "✅ Password reset email sent! Check your inbox to reset your password."
      );
      setShowForgotPasswordForm(false);
      setEmail("");
    } catch (error) {
      //console.error("Forgot Password Error:", error);
      toast.error("⚠️ Something went wrong. Try again.");
    }
  };

  // Register or Login
  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanEmail = email.trim().toLowerCase();

    try {
      if (isRegister) {
        const userCredential = await createUserWithEmailAndPassword(auth, cleanEmail, password);
        const uid = userCredential.user.uid;

        await setDoc(doc(db, "companies", uid), {
          companyName,
          email: cleanEmail,
          phoneNumber,
          createdAt: new Date(),
        });

        localStorage.setItem("companyId", uid);
        toast.success("🎉 Registration Successful");
        setTimeout(() => navigate("/AdminPannel"), 1000);
      } else {
        const userCredential = await signInWithEmailAndPassword(auth, cleanEmail, password);
        const uid = userCredential.user.uid;

        const companySnap = await getDoc(doc(db, "companies", uid));

        if (companySnap.exists()) {
          localStorage.setItem("companyId", uid);
          toast.success("✅ Login Successful");
          setTimeout(() => navigate("/AdminPannel"), 1000);
        } else {
          toast.error("❌ Access Denied - No company profile found.");
        }
      }
    } catch (error) {
      //console.error("Auth Error:", error);

      switch (error.code) {
        case "auth/email-already-in-use":
          toast.error("❌ This email is already registered. Use another email.");
          break;
        case "auth/wrong-password":
        case "auth/invalid-credential":
          toast.error("❌ Wrong password.");
          break;
        case "auth/user-not-found":
          toast.error("❌ No account found with this email.");
          break;
        case "auth/invalid-email":
          toast.error("❌ Invalid email format.");
          break;
        default:
          toast.error("⚠️ Something went wrong. Try again.");
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="bg-white p-6 rounded-lg shadow max-w-md mx-auto mt-10">
        <h2 className="text-xl font-bold text-center mb-4">
          {isRegister ? "Register Your Company" : "Employers Login"}
        </h2>

        {showForgotPasswordForm ? (
          // ✅ Forgot Password Form
          <div>
            <input
              type="email"
              placeholder="Enter your company email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mb-3 px-4 py-2 border rounded"
              required
            />
            <button
              onClick={handleForgotPassword}
               className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700"
            >
              Submit & check mail
            </button>
            <p
              className="text-sm mt-2 text-gray-500 text-center cursor-pointer underline"
              onClick={() => setShowForgotPasswordForm(false)}
            >
              Back to {isRegister ? "Register" : "Login"}
            </p>
          </div>
        ) : (
          // ✅ Register / Login Form
          <form onSubmit={handleSubmit}>
            {isRegister && (
              <>
                <input
                  type="text"
                  placeholder="Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className="w-full mb-3 px-4 py-2 border rounded"
                  required
                />
                <input
                  type="text"
                  placeholder="Phone Number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="w-full mb-3 px-4 py-2 border rounded"
                  maxLength={10}
                  pattern="[0-9]{10}"
                  required
                />
              </>
            )}

            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mb-3 px-4 py-2 border rounded"
              required
              autoComplete="email"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mb-3 px-4 py-2 border rounded"
              required
              autoComplete="current-password"
            />

            {!isRegister && (
              <p
                className="text-blue-600 text-sm mt-1 mb-3 cursor-pointer underline"
                onClick={() => setShowForgotPasswordForm(true)}
              >
                Forgot Password?
              </p>
            )}

            <button
              type="submit"
              className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700"
            >
              {isRegister ? "Register" : "Login"}
            </button>
          </form>
        )}

        {!showForgotPasswordForm && (
          <p className="text-center mt-4 text-sm text-gray-500">
            {isRegister ? "Already have an account?" : "Not Registered as Employer?"}{" "}
            <button
              onClick={() => {
                setIsRegister(!isRegister);
                setCompanyName("");
                setPhoneNumber("");
              }}
              className="text-blue-600 underline"
            >
              {isRegister ? "Login" : "Create Account"}
            </button>
          </p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default CompanyAuth;
